import {
  AffiliatesConfigPartialState,
  ControlConfigPartialState,
  ControlConfigState,
} from 'common/types';

import createRootSelector from '../apps/core/selectors/createRootSelector';

type ConfigPartialState =
  | ControlConfigPartialState
  | AffiliatesConfigPartialState;

export const affiliateConfigSelector = ({
  config,
}: AffiliatesConfigPartialState) => config;

export const configSelector = ({ config }: ConfigPartialState) => config;

export const aclRootSelector = createRootSelector(
  configSelector,
  (config) => (config as ControlConfigState)?.acl,
);

export const whiteLabelDomainsRootSelector = createRootSelector(
  affiliateConfigSelector,
  ({ whiteLabelDomains }) => whiteLabelDomains,
);

export const accountManagerRootSelector = createRootSelector(
  affiliateConfigSelector,
  ({ accountManager }) => accountManager,
);

export const getIsCaptchaEnabled = ({ config }: ConfigPartialState) => {
  const { isCaptchaEnabled } = config.features;

  return typeof isCaptchaEnabled === 'undefined' ? true : isCaptchaEnabled;
};

export const getProxyUrl = ({ config }: ConfigPartialState) =>
  config.url!.proxyUrl;

export const getBaseUrl = ({ config }: ConfigPartialState) =>
  config.url?.baseUri;

export const getApiUrl = ({ config }: ConfigPartialState) => config.url?.apiUrl;

export const getGoUrl = ({ config }: ConfigPartialState) => config.url?.goUrl;

export const getAppUrl = ({ config }: ConfigPartialState) => config.url?.appUrl;

export const isIncarnatedConfigSelector = ({ config }: ConfigPartialState) =>
  Boolean(config.isIncarnated);
